import { render, staticRenderFns } from "./orderMatchingList.vue?vue&type=template&id=995da94c"
import script from "./orderMatchingList.vue?vue&type=script&lang=js"
export * from "./orderMatchingList.vue?vue&type=script&lang=js"
import style0 from "./orderMatchingList.vue?vue&type=style&index=0&id=995da94c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports